import PrivateRoute from '@web/components/PrivateRoute';
import Timesheet from '@web/containers/Timesheet';

export function Component() {
  return (
    <PrivateRoute paramsToValidate={{ id: 'uuid' }}>
      <Timesheet />
    </PrivateRoute>
  );
}

Component.displayName = 'Timesheet';
